import { Moment } from 'moment';
import { toMoment } from '@shared/utils/date';
import { PeriodTypes } from '@shared/utils/constants';
import PeriodScheduleItem from '@api/models/period-schedule-item';
import calculateSchedule from './calculateSchedule';

const calculateMinMaxDurationDays = ({
	items,
	laycanFrom,
	laycanTo,
	deliveryDate,
	useVariance = true,
}: {
	items: PeriodScheduleItem[];
	laycanTo: Moment;
	laycanFrom?: Moment | null;
	deliveryDate?: Moment | null;
	useVariance?: boolean;
}): [number | null, number | null] => {
	const schedule = calculateSchedule({
		items,
		deliveryDate,
		laycanTo,
		useVariance,
	});

	const filtered = schedule.filter((s) => s.periodType === PeriodTypes.DECLARED);
	const lastEntry = filtered[filtered.length - 1];

	if (lastEntry == null) {
		return [null, null];
	}

	const minStartTime = deliveryDate ?? laycanTo;
	const maxStartTime = deliveryDate ?? laycanFrom ?? laycanTo;

	const minDays = toMoment(lastEntry.to).diff(minStartTime, 'hours', true) / 24;
	const maxDays = toMoment(lastEntry.maxTo).diff(maxStartTime, 'hours', true) / 24;

	return [minDays, maxDays];
};

export default calculateMinMaxDurationDays;
